module.exports = __webpack_public_path__ + "assets/7ccad47702715e17a270d2890ccf35da.png";